import React from "react";

const Logo = () => {
  return (
    <div className="logo">
      <img src="./img/logo.png" alt="logo" />
      <h3>AW World</h3>
    </div>
  );
};

export default Logo;
